import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App'; // ...existing App.jsx
import './index.css';    // ...existing Tailwind import

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
